import { ReportSettings } from './reportSettings.ts';
import { InfoIcon } from '../../../components/dialog-portal/infoIcon.tsx';

interface Props {
    reportSettings: ReportSettings;
    setReportSettings: (reportSettings: ReportSettings) => void;
    onShowOperatorsInfo: () => void;
}

export function ReportOperatorControl({
    reportSettings,
    setReportSettings,
    onShowOperatorsInfo,
}: Props) {
    return (
        <section className='report-controls__section report-controls__section--inline'>
            <label>
                <input
                    type='checkbox'
                    checked={reportSettings.showOperators}
                    onChange={(event) => setReportSettings({
                        ...reportSettings,
                        showOperators: event.target.checked,
                    })}
                />
                Show operators
            </label>
            <InfoIcon onClick={onShowOperatorsInfo} title='Operator count rules' />
        </section>
    );
}
